import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, eur } from "../../lib/api";

export const OrdersTab = () => {
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    api.get("/orders").then((r) => setOrders(r.data)).catch(() => setOrders([]));
  }, []);

  if (orders === null) return <div className="h-32 bg-[#141414] animate-pulse border border-white/5" />;

  if (orders.length === 0) {
    return (
      <div className="border border-white/5 py-16 text-center" data-testid="orders-empty">
        <p className="font-serif text-2xl text-zinc-400 italic">No conquests yet</p>
        <Link
          to="/shop"
          className="mt-6 inline-block text-xs tracking-[0.3em] uppercase text-gold hover:text-gold-hover transition-colors"
        >
          Begin with the Collections
        </Link>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4" data-testid="orders-list">
      {orders.map((o) => (
        <div key={o.id} className="border border-white/10 bg-[#141414] p-6 md:p-8" data-testid={`order-${o.id}`}>
          <div className="flex justify-between items-start flex-wrap gap-4">
            <div>
              <p className="text-xs tracking-[0.3em] uppercase text-gold">Order {o.id.slice(0, 8).toUpperCase()}</p>
              <p className="text-xs text-zinc-600 mt-1">
                {new Date(o.created_at).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}
              </p>
            </div>
            <div className="text-right">
              <p className="font-serif text-xl text-gold">{eur(o.total)}</p>
              <p className="text-[10px] tracking-[0.25em] uppercase text-maroon-light mt-1">{o.status}</p>
            </div>
          </div>
          <div className="mt-5 pt-5 border-t border-white/5 flex flex-col gap-2">
            {o.items.map((i, idx) => (
              <p key={idx} className="text-sm text-zinc-400">
                {i.name} <span className="text-zinc-600">&mdash; Size {i.size}, &times;{i.qty}</span>
              </p>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
